interface EmptyStateProps {
  icon?: string;
  title: string;
  description?: string;
  actionLabel?: string;
  onAction?: () => void;
}

export default function EmptyState({
  icon = 'ri-inbox-line',
  title,
  description,
  actionLabel,
  onAction,
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center py-16 px-4 text-center">
      <span className="w-16 h-16 rounded-full bg-background-100 flex items-center justify-center mb-4">
        <i className={`${icon} text-3xl text-foreground-400`}></i>
      </span>
      <h3 className="text-base font-medium text-foreground-900">{title}</h3>
      {description && <p className="mt-2 text-sm text-foreground-500 max-w-md">{description}</p>}
      {actionLabel && onAction && (
        <button
          type="button"
          onClick={onAction}
          className="mt-5 px-5 h-9 rounded-md bg-primary-500 text-background-950 text-sm font-medium hover:bg-primary-600 cursor-pointer whitespace-nowrap transition-colors"
        >
          {actionLabel}
        </button>
      )}
    </div>
  );
}